module.exports = __webpack_public_path__ + "img/icons-40-perks-think-big.122927eb.svg";